import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { AmazonMWSCopySource } from 'app/model/pipeline/copysource/amazon-mws.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonMWSCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class AmazonMWSCopySourceAdapter extends CopySourceAdapter<AmazonMWSCopySource, Model.AmazonMWSSource> {
    protected override async _toResource(copySource: AmazonMWSCopySource): Promise<Model.AmazonMWSSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(AmazonMWSCopySource).name);
    }

    protected override async _toModel(
        resource: Model.AmazonMWSSource,
        copyActivity: CopyActivity
    ): Promise<AmazonMWSCopySource> {
        return this._toTabularModel(resource, copyActivity, AmazonMWSCopySource.MODEL);
    }
}
